import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataFlowV2Service from "src/modules/data-protection/apis/DataFlowV2Service";
import { isAssetCounterpartType } from "../helpers/flowForm";

export const DATA_FLOW_ASSETS_QUERY_KEY = "data-flow-assets";

const useDataFlowAssets = ({ type, enabled = false, t } = {}) => {
    return useQuery({
        queryKey: [DATA_FLOW_ASSETS_QUERY_KEY, type],
        queryFn: async () => {
            const service = DataFlowV2Service.getInstance();
            const response =
                type === "hardware"
                    ? await service.getHardwareAssets()
                    : await service.getSoftwareAssets();

            return response?.data?.assets || response?.assets || [];
        },
        enabled: Boolean(enabled && isAssetCounterpartType(type)),
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching counterparts."), {
                type: "error",
            });
        },
    });
};

export default useDataFlowAssets;
